import { Badge } from "@salestrak/ui";

import { hasUnpublishedChanges, type Form } from "#app/lib/forms";

export function FormStatusBadge({
  form,
  showLive = false,
}: {
  form: Form;
  showLive?: boolean;
}) {
  if (form.status === "draft") return <Badge tone="outline">Draft</Badge>;
  const staged = hasUnpublishedChanges(form);
  if (form.status === "closed") {
    return <Badge tone="soft">{staged ? "Closed · Draft" : "Closed"}</Badge>;
  }
  if (staged) {
    return (
      <Badge color="orange" tone="soft">
        Live · Draft
      </Badge>
    );
  }
  if (!showLive) return null;
  return (
    <Badge color="green" tone="soft">
      Live
    </Badge>
  );
}

/** Quiet words for the builder bar: a colored chip there would compete with Publish. */
export function formStatusLabel(form: Form): string {
  if (form.status === "draft") return "Draft";
  const status = form.status === "closed" ? "Closed" : "Live";
  return hasUnpublishedChanges(form) ? `${status} · Unpublished changes` : status;
}
